if (!customElements.get('bundle-selector')) {
  customElements.define('bundle-selector', class BundleSelector extends HTMLElement {
    constructor() {
      super()

      setTimeout(() => {

        const allPack = this.querySelectorAll('.product-pack')

        allPack.forEach(item => item.addEventListener('click', e => {
          allPack.forEach(item => item.classList.remove('selected'))

          const target = e.target.closest('.product-pack')
          target.classList.add('selected')
          const available = target.getAttribute('data-available') === 'true'

          if (!available) {
            this.querySelector('.bundle-btn').style.display = 'none'
            this.querySelector('.bundle-btn.sold-out').style.display = 'flex'
            this.querySelector('.bundle-btn.sold-out span').innerHTML = target.getAttribute('data-coming-text')
            // return
          } else {
            this.querySelector('.bundle-btn').style.display = 'flex'
            this.querySelector('.bundle-btn.sold-out').style.display = 'none'
          }

          if (target.getAttribute('data-size') === '1') {
            document.querySelector('bundle-swatch[data-size="2"]').style.display = 'none'
            this.selectedSize = 1
          } else {
            document.querySelector('bundle-swatch[data-size="2"]').style.display = 'block'
            this.selectedSize = 2
          }

          this.computePrice()
          setTimeout(() => {
            document.querySelector('bundle-swatch').checkSoldOutState()
          }, 50)
        }))

        this.querySelector('.with-pack')?.addEventListener('click', e => {
          const target = e.target.closest('.with-pack')
          target.classList.toggle('selected')

          this.selectedWith = target.classList.contains('selected')

          this.computePrice()
        })

        this.querySelector('.bundle-btn').addEventListener('click', e => {
          const addArr = []

          if (this.selectedWith) {
            addArr.push({
              id: this.querySelector('.with-pack').getAttribute('data-id'),
              quantity: 1,
            })
          }

          if (this.selectedSize === 1) {
            addArr.push({
              id: this.querySelector('.swatch-selected').getAttribute('data-id'),
              quantity: 1,
            })
          } else {
            const eles = Array.from(this.querySelectorAll('.swatch-selected')).map(item => item.getAttribute('data-value'))

            addArr.push({
              id: this.querySelector(`[data-option="${eles.join('/')}"]`).value,
              quantity: 1,
            })
          }

          this.querySelector('.bundle-btn').classList.add('loading')
          CartJS.addItems(addArr)

          const observer = new MutationObserver((mutations) => {
            const cartPopup = document.getElementById('CartPopup')
            if (cartPopup) {
              this.querySelector('.bundle-btn').classList.remove('loading')
              observer.disconnect()
            }
          })

          observer.observe(document.body, {
            childList: true,
            subtree: true
          })
        })
      }, 20);
    }

    selectedWith = false
    selectedSize = 1

    computePrice() {
      this.querySelectorAll('.bundle-total-price').forEach(item => item.style.display = 'none')
      console.log(this.selectedSize, this.selectedWith)
      if (this.selectedSize === 1 && this.selectedWith) {
        this.querySelector('.bundle-total-price.with-single').style.display = 'block'
      } else if (this.selectedSize === 1 && !this.selectedWith) {
        this.querySelector('.bundle-total-price.single').style.display = 'block'
      } else if (this.selectedSize === 2 && this.selectedWith) {
        this.querySelector('.bundle-total-price.with-bundle').style.display = 'block'
      } else {
        this.querySelector('.bundle-total-price.bundle').style.display = 'block'
      }
    }
  })

}

if (!customElements.get('bundle-swatch')) {
  customElements.define('bundle-swatch', class BundleSwatch extends HTMLElement {
    constructor() {
      super()

      setTimeout(() => {
        const allSwatch = this.querySelectorAll('.swatch-custom-image')

        allSwatch.forEach(item => item.addEventListener('click', e => {
          allSwatch.forEach(item => item.classList.remove('swatch-selected'))

          const target = e.target.closest('.swatch-custom-image')
          target.classList.add('swatch-selected')

          this.querySelector('.swatch-variant-name').innerHTML = target.getAttribute('data-value')

          this.checkSoldOutState(target)

          this.setAttribute('data-selected', target.getAttribute('data-value'))
        }))

        if (this.style.display !== 'none') {
          this.checkSoldOutState()
        }
      }, 50);
    }

    checkSoldOutState() {
      const hasSoldOut = document.querySelector('.swatch-custom-image.swatch-selected.sold-out')
      if (hasSoldOut) {
        document.querySelector('.bundle-btn').style.display = 'none'
        document.querySelector('.bundle-btn.sold-out').style.display = 'flex'
      } else {
        document.querySelector('.bundle-btn').style.display = 'flex'
        document.querySelector('.bundle-btn.sold-out').style.display = 'none'
      }
    }
  })
}